import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue";
const _hoisted_1 = {
  class: "listContainer"
};
const _hoisted_2 = {
  key: 0,
  class: "listItems"
};
const _hoisted_3 = {
  key: 1,
  class: "noNotification"
};
const _hoisted_4 = {
  class: "noNotificationTitle"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_NotificationItem = _resolveComponent("NotificationItem");
  const _component_loader = _resolveComponent("loader");
  const _component_infinite_loading = _resolveComponent("infinite-loading");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_ctx.notificationList.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_2, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.notificationList, notification => {
    return _openBlock(), _createElementBlock("div", {
      key: notification.key,
      class: "notificationListItem"
    }, [_createVNode(_component_NotificationItem, {
      notification: notification
    }, null, 8, ["notification"])]);
  }), 128)), _ctx.notificationList.length > 0 ? (_openBlock(), _createBlock(_component_infinite_loading, {
    key: 0,
    ref: "infiniteLoader",
    onInfinite: _ctx.infiniteHandler
  }, {
    spinner: _withCtx(() => [_createVNode(_component_loader, {
      "spinner-size": "spinnersSmall"
    })]),
    "no-more": _withCtx(() => _cache[0] || (_cache[0] = [_createElementVNode("div", null, null, -1)])),
    _: 1
  }, 8, ["onInfinite"])) : _createCommentVNode("", true)])) : _createCommentVNode("", true), _ctx.notificationList.length === 0 && _ctx.loaded === true ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t("notification.none")), 1)])) : _createCommentVNode("", true)]);
}